import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { listPublishedArticles } from '../services/blog';
import './BlogCarousel.css';

function formatDate(d) {
  if (!d) return '';
  return new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' }).format(d);
}

function BlogCarousel() {
  const [articles, setArticles] = useState([]);
  const [ready, setReady] = useState(false);
  const trackRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    listPublishedArticles({ max: 8 })
      .then((rows) => {
        if (cancelled) return;
        setArticles(rows);
        setReady(true);
      })
      .catch(() => {
        if (cancelled) return;
        setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('.carousel-card');
    const step = card ? card.getBoundingClientRect().width + 24 : el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  if (!ready || articles.length === 0) return null;

  return (
    <section className="blog-carousel-section">
      <div className="blog-carousel-container">
        <div className="blog-carousel-head">
          <div>
            <span className="blog-carousel-kicker">L'ACTU</span>
            <h2>Les derniers articles</h2>
          </div>
          <Link to="/blog" className="blog-carousel-all">
            Voir tout <ArrowRight size={18} />
          </Link>
        </div>

        <div className="blog-carousel-stage">
          <button
            type="button"
            className="blog-carousel-arrow left"
            onClick={() => scrollBy(-1)}
            aria-label="Précédent"
          >
            <ChevronLeft size={28} />
          </button>

          <div className="blog-carousel-track" ref={trackRef}>
            {articles.map((a) => (
              <Link
                key={a.id}
                to={`/blog/${a.slug}`}
                className="carousel-card"
              >
                <div className="carousel-card-cover-wrap">
                  {a.coverImage && (
                    <img
                      src={a.coverImage}
                      alt=""
                      className="carousel-card-cover"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className="carousel-card-body">
                  {a.category && (
                    <span className="carousel-card-category">{a.category}</span>
                  )}
                  <h3 className="carousel-card-title">{a.title}</h3>
                  <p className="carousel-card-excerpt">{a.excerpt}</p>
                  <div className="carousel-card-meta">
                    {formatDate(a.publishedAt)}
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <button
            type="button"
            className="blog-carousel-arrow right"
            onClick={() => scrollBy(1)}
            aria-label="Suivant"
          >
            <ChevronRight size={28} />
          </button>
        </div>
      </div>
    </section>
  );
}

export default BlogCarousel;
